<template>
  <!-- ケアオーケストレーターディーラー施設管理 -->
  <div id="CODealerSettingHospital">
    <div id="container-center">
      <coSettingNavi :pageid='"CODealerSettingHospital"' :careOrchestratorInstitutionId='this.careOrchestratorInstitutionId' :certificationFlag='this.certificationFlag' :searchConditions='this.searchConditions'></coSettingNavi>
      <settingHospital :careOrchestratorInstitutionId='this.careOrchestratorInstitutionId' />
      <div style="margin-top:10px;">
        <b-button class="backbutton is-primary" @click="back">戻る</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/guest/careorchestrator/SettingNaviBar";
import contents from "@/components/mock/guest/careorchestrator/setting/ExternalHospitalContents";

export default {
  name: "CODealerSettingHospital",
  methods: {
    back:  function() {
      this.$router.push({ 
        name: "CODealerHospitalSearch",
        params: { searchConditions: this.searchConditions }
      });
    },
  },
  data() {
    let searchConditions = this.$route.params["searchConditions"];
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    let certificationFlag = this.$route.params["certificationFlag"];
    var data = this.$route.params["data"];
    return {
      careOrchestratorInstitutionId: careOrchestratorInstitutionId,
      certificationFlag: certificationFlag,
      searchConditions: searchConditions,
      data
    };
  },
  filters: {},
  components: {
    coSettingNavi: naviBar,
    settingHospital: contents
  },
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/CODealerSettingHospital.vue